<script setup>
import { useRouter } from 'vue-router'

const props = defineProps({
    route: {
        type: String,
        required: true
    },
    loading: {
        type: Boolean,
        default: false
    },
    size: {
        type: String,
        default: 'md', // opções: sm, md, lg, full
        validator: (v) => ['sm', 'md', 'lg', 'full'].includes(v)
    }
})

const router = useRouter()

const goBack = () => {
    router.push(props.route) // agora aceita "/" ou "/login" etc
}

const sizeClasses = {
    sm: 'px-3 py-1 text-sm',
    md: 'px-4 py-2 text-base',
    lg: 'px-5 py-3 text-lg',
    full: 'w-100 py-2'
}
</script>

<template>
    <v-btn
        type="button"
        :loading="loading"
        class="btn btn-outline-primary mb-3 d-flex align-items-center justify-center"
        :class="sizeClasses[size]"
        variant="tonal"
        @click="goBack"
    >
        <i class="material-symbols-outlined mr-2">arrow_back</i>
        {{ $t('common.labels.back') }}
    </v-btn>
</template>


<style lang="scss" scoped>
.trezo-card{
    margin-bottom: -15px;

    button,
    a {
        margin: {
            right: 15px;
            bottom: 15px;
        }
        display: inline-block !important;
        padding: 14px 35px !important;
        width: auto;
        height: auto;
        font: {
            size: var(--fontSize) !important;
            weight: 500 !important;
        }
        &.v-btn--icon {
            width: 56px;
            height: 56px;
            padding: 0 !important;
            color: var(--whiteColor);
        }
        &.trezo {
            color: var(--primaryColor);
        }
        &.fw-bold {
            font-weight: 700 !important;
        }
        &.fw-semibold {
            font-weight: 600 !important;
        }
        &.d-block {
            text-align: center !important;
            display: block !important;
            width: 100% !important;
        }
    }
}
</style>
